"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _PageUnloadContext = require("@insided/shared/services/PageUnloadContext");

var _Skeleton = require("@insided/destination/uikit/Skeleton");

var _htmlParser = _interopRequireDefault(require("@insided/deprecated-preact-components/utils/htmlParser"));

var _translations = require("../../libs/translationsUtils/translations");

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _service = require("./service");

var _DynamicImport = _interopRequireDefault(require("@insided/shared/utils/DynamicImport"));

var _utils = require("./utils");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Editor = (0, _DynamicImport.default)(function () {
  return import('@insided/shared/uikit/Editor');
}, {
  fallback: (0, _preact.h)("output", {
    "aria-live": "polite",
    "aria-busy": "true",
    "aria-label": "Loading editor"
  }, (0, _preact.h)(_Skeleton.TextSkeleton, {
    style: {
      height: '30px'
    }
  }), (0, _preact.h)(_Skeleton.RectangleSkeleton, {
    height: "300px"
  }))
});
var DEFAULT_MESSAGE_LENGTH = 3;
var cssAnchorName = 'private-message-editor';
exports.cssAnchorName = cssAnchorName;

var PrivateMessageEditor = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(PrivateMessageEditor, _Component);

  var _super = _createSuper(PrivateMessageEditor);

  function PrivateMessageEditor() {
    var _this;

    (0, _classCallCheck2.default)(this, PrivateMessageEditor);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      // eslint-disable-next-line react/no-unused-state
      content: '',
      errors: [],
      isLoading: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleSubmit", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(content) {
        var parsedContent, urlParams, conversationId, form, csrfToken, formToken, token, params, errors, newErrors, _error$response$data, _error$response$data$, _error$response$data2, _error$response$data3, _error$response$data4, errorMessage;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                parsedContent = _htmlParser.default.stripHtml(content);

                if (!(parsedContent.length < DEFAULT_MESSAGE_LENGTH)) {
                  _context.next = 4;
                  break;
                }

                _this.setState(function (prevState) {
                  return {
                    errors: prevState.errors.concat({
                      errorMessage: (0, _translations.t)('Forum', 'private.message.error.length')
                    })
                  };
                });

                return _context.abrupt("return");

              case 4:
                _this.setState({
                  isLoading: true
                });

                _context.prev = 5;
                urlParams = new URLSearchParams(window.location.search);
                conversationId = urlParams.has('with') ? urlParams.get('with') : '';
                form = document.querySelector('.js-wysiwyg-form');
                csrfToken = '';

                if (form !== null) {
                  formToken = form.querySelector('[name="conversationMessage[_token]"]');

                  if (formToken !== null) {
                    csrfToken = formToken.value;
                  }
                }

                _context.next = 13;
                return (0, _service.getToken)(csrfToken);

              case 13:
                token = _context.sent;
                params = new URLSearchParams();
                params.append('conversationMessage[content]', (0, _utils.transformEncodedHtml)(content));
                params.append('conversationMessage[_token]', token);

                if (!(!token || !conversationId)) {
                  _context.next = 20;
                  break;
                }

                _this.setState(function () {
                  return {
                    isLoading: false
                  };
                });

                return _context.abrupt("return");

              case 20:
                _context.next = 22;
                return (0, _service.sendMessage)(conversationId, params);

              case 22:
                errors = _context.sent;

                if (!(errors !== null && errors !== void 0 && errors.length)) {
                  _context.next = 27;
                  break;
                }

                newErrors = errors.map(function (error) {
                  return {
                    errorMessage: error
                  };
                });

                _this.setState(function (prevState) {
                  return {
                    errors: prevState.errors.concat(newErrors),
                    isLoading: false
                  };
                });

                return _context.abrupt("return");

              case 27:
                _this.setState({
                  errors: []
                });

                window.CKEDITOR.instances.editor1.setData('');
                window.location.reload();
                _context.next = 36;
                break;

              case 32:
                _context.prev = 32;
                _context.t0 = _context["catch"](5);
                errorMessage = ((_error$response$data = _context.t0.response.data) === null || _error$response$data === void 0 ? void 0 : (_error$response$data$ = _error$response$data.errors) === null || _error$response$data$ === void 0 ? void 0 : _error$response$data$.pagetext) || ((_error$response$data2 = _context.t0.response.data) === null || _error$response$data2 === void 0 ? void 0 : (_error$response$data3 = _error$response$data2.errors) === null || _error$response$data3 === void 0 ? void 0 : _error$response$data3.content) || ((_error$response$data4 = _context.t0.response.data) === null || _error$response$data4 === void 0 ? void 0 : _error$response$data4.errors) || "Something's gone wrong";

                _this.setState(function (prevState) {
                  return {
                    errors: prevState.errors.concat({
                      errorMessage: errorMessage
                    })
                  };
                });

              case 36:
                _this.setState({
                  isLoading: false
                });

              case 37:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[5, 32]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onChange", function (content) {
      // eslint-disable-next-line react/no-unused-state
      _this.setState({
        content: content
      });
    });
    return _this;
  }

  (0, _createClass2.default)(PrivateMessageEditor, [{
    key: "componentDidMount",
    value: // eslint-disable-next-line class-methods-use-this
    function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // switch off beforeunload to prevent default browser alert on page leave
                window.addEventListener('beforeunload', function (e) {
                  e.stopImmediatePropagation();
                }, true);

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var props = this.props;
      return (0, _preact.h)("div", {
        className: "private-messages-editor",
        "data-qa": "private-messages-editor"
      }, (0, _preact.h)("div", {
        className: "private-messages-editor-phrases-hidden"
      }, (0, _preact.h)(_phrase.default, {
        p: "private.message.placeholder"
      }), (0, _preact.h)(_phrase.default, {
        p: "private.message.error.length"
      })), (0, _preact.h)(_PageUnloadContext.PageUnloadContext.Consumer, null, function (_ref2) {
        var lock = _ref2.lock;
        return (0, _preact.h)(Editor, (0, _extends2.default)({}, props, {
          disableFileAttachments: true,
          isControl: false,
          errors: _this2.state.errors,
          isLoading: _this2.state.isLoading,
          onSubmit: /*#__PURE__*/function () {
            var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(content) {
              return _regenerator.default.wrap(function _callee3$(_context3) {
                while (1) {
                  switch (_context3.prev = _context3.next) {
                    case 0:
                      _context3.next = 2;
                      return _this2.handleSubmit(content);

                    case 2:
                      return _context3.abrupt("return", _context3.sent);

                    case 3:
                    case "end":
                      return _context3.stop();
                  }
                }
              }, _callee3);
            }));

            return function (_x2) {
              return _ref3.apply(this, arguments);
            };
          }(),
          sendButtonText: props.sendButtonText,
          onChange: function onChange(content) {
            _this2.onChange(content);

            lock(content);
          },
          showEmbedMedia: false
        }));
      }));
    }
  }]);
  return PrivateMessageEditor;
}(_preact.Component);

var _default = PrivateMessageEditor;
exports.default = _default;